var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRsvp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2198 9.27101L14.2168 3.90837C13.499 3.35867 12.5017 3.35867 11.7839 3.90837L4.78097 9.27101C4.28654 9.64961 3.99658 10.2368 3.99658 10.8596V19.5028C3.99658 20.6078 4.89239 21.5036 5.99742 21.5036H20.0032C21.1083 21.5036 22.0041 20.6078 22.0041 19.5028V10.8596C22.0041 10.2369 21.7142 9.64963 21.2198 9.27101Z",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18408 10.0158L11.7836 15.8353C12.5015 16.385 13.4988 16.385 14.2166 15.8353L21.8177 10.0146",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5008 9.74902L12.4999 11.2496L11.4995 10.4993",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsvp);
export default __webpack_public_path__ + "static/media/RSVP.e23aeefd.svg";
export { ForwardRef as ReactComponent };